import { render, staticRenderFns } from "./Designated.vue?vue&type=template&id=4cb9a240&scoped=true&"
import script from "./Designated.vue?vue&type=script&lang=js&"
export * from "./Designated.vue?vue&type=script&lang=js&"
import style0 from "./Designated.vue?vue&type=style&index=0&id=4cb9a240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9a240",
  null
  
)

export default component.exports